import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import ContractingContractAdjustment from "./ContractingContractAdjustment";

export default class ContractingContract extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'contractingcontract',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.refreshData();
	}
	save(e) {
		e.preventDefault();

		if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

		var guarantees = [];

		this.state.data.record.guarantees.forEach(i => {
			var clone = Object.assign({}, i);
			clone.expiryDate = this.convertMomentToDb(clone.expiryDate);
			guarantees.push(clone);
		});

		this.httpPost("api/v1/contractingcontract/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			endDate: this.convertMomentToDb(this.state.data.record.endDate),
			startDate: this.convertMomentToDb(this.state.data.record.startDate),
			clientId: this.state.data.record.clientId,
			code: this.state.data.record.code,
			status: this.state.data.record.status,
			contractorId: this.state.data.record.contractorId,
			notes: this.state.data.record.notes,
			title: this.state.data.record.title,
			solutionId: this.state.data.record.solutionId,
			originalAmount: this.state.data.record.originalAmount,
			guarantees,
			retentions: this.state.data.record.retentions,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("قرارداد با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	start(e) {
		e.preventDefault();

		this.httpPost("api/v1/contractingcontract/start", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("قرارداد با موفقیت به جریان افتاد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setClient(e) {
		if (e.value == -1) {
			this.state.data.record.clientId = this.defaultGuid();
			this.state.data.record.clientName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.clientId = e.value;
		this.state.data.record.clientName = e.label;
		this.setState({ data: this.state.data });
	}
	setContractor(e) {
		if (e.value == -1) {
			this.state.data.record.contractorId = this.defaultGuid();
			this.state.data.record.contractorName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.contractorId = e.value;
		this.state.data.record.contractorName = e.label;
		this.setState({ data: this.state.data });
	}
	setSolution(e) {
		this.state.data.record.solutionId = e.value;
		this.state.data.record.solutionName = e.label;
		this.setState({ data: this.state.data });
	}
	refreshData() {
		this.httpPost("api/v1/contractingcontract/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	getBlankGuarantee() {
		return {
			id: this.uuidv4(),
			issuer: '',
			amount: 0,
			guaranteeType: 1,
			expiryDate: null,
		}
	}
	addNewGuarantee() {
		this.state.data.record.guarantees.push(this.getBlankGuarantee());
		this.setState({ data: this.state.data });
	}
	removeGuarantee(id) {
		var temp = [];
		this.state.data.record.guarantees.forEach(t => {
			if (t.id !== id) temp.push(t);
		});

		this.state.data.record.guarantees = temp;
		this.setState({ data: this.state.data });
	}
	setGuarantee(id, f, e) {
		this.state.data.record.guarantees.forEach(t => {
			if (t.id === id) {
				t[f] = e;
			}
		});

		this.setState({ data: this.state.data });
	}
	getBlankRetention() {
		return {
			id: this.uuidv4(),
			amount: 0,
			type: 1,
		}
	}
	addNewRetention() {
		this.state.data.record.retentions.push(this.getBlankRetention());
		this.setState({ data: this.state.data });
	}
	removeRetention(id) {
		var temp = [];
		this.state.data.record.retentions.forEach(t => {
			if (t.id !== id) temp.push(t);
		});

		this.state.data.record.retentions = temp;
		this.setState({ data: this.state.data });
	}
	setRetention(id, f, e) {
		this.state.data.record.retentions.forEach(t => {
			if (t.id === id) {
				t[f] = e;
			}
		});

		this.setState({ data: this.state.data });
	}
	onAddAdjustment() {
		this.removeKeyDown();
		this.showComponents({ component: <ContractingContractAdjustment ContractingContractId={this.state.data.record.id} Caller={this} /> });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">قرارداد پیمانکاری</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>

							<ul className="nav nav-tabs mt-n3" role="tablist">
								<li className="nav-item" role="presentation">
									<a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>قرارداد</span></a>
								</li>
								<li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab2" aria-selected="false" tabindex="-1" role="tab"><span>تضامین</span></a>
								</li>
								<li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab3" aria-selected="false" tabindex="-1" role="tab"><span>سپرده ها</span></a>
								</li>
								{this.state.data.record.status > 1 && <li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab4" aria-selected="false" tabindex="-1" role="tab"><span>تعدیلات قیمتی</span></a>
								</li>}
							</ul>

							<div className="tab-content">
								<div className="tab-pane active" id="tab1" role="tabpanel">
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">عنوان قرارداد</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.title}</b>
													:
													<input onChange={e => this.state.data.record.title = e.target.value} defaultValue={this.state.data.record.title} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label for="invoiceContact" className="title1">پروژه<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.solutionName}</b>
													:
													<SelectAsync
														value={!this.isNull(this.state.data.record.solutionId) && this.state.data.record.solutionId != this.defaultGuid() ? [{ value: this.state.data.record.solutionId, label: this.state.data.record.solutionName }] : null}
														isMulti={false}
														placeholder="انتخاب پروژه"
														defaultOptions
														loadOptions={(inputValue, callback) => this.loadSolutionsOptions(inputValue, callback)}
														onChange={e => this.setSolution(e)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label for="invoiceContact" className="title1">کارفرما<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.clientName}</b>
													:
													<SelectAsync
														value={!this.isNull(this.state.data.record.clientId) && this.state.data.record.clientId != this.defaultGuid() ? [{ value: this.state.data.record.clientId, label: this.state.data.record.clientName }] : null}
														isMulti={false}
														placeholder="انتخاب کارفرما"
														defaultOptions
														loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 12)}
														onChange={e => this.setClient(e)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label for="invoiceContact" className="title1">پیمانکار<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.recordContractorName}</b>
													:
													<SelectAsync
														value={!this.isNull(this.state.data.record.contractorId) && this.state.data.record.contractorId != this.defaultGuid() ? [{ value: this.state.data.record.contractorId, label: this.state.data.record.contractorName }] : null}
														isMulti={false}
														placeholder="انتخاب کارفرما"
														defaultOptions
														loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 11)}
														onChange={e => this.setContractor(e)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceDate" className="title1">تاریخ شروع<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.dateString}</b>
													:
													<DatePicker
														inputReadOnly={false}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.data.record.startDate = e }}
														value={this.getFormatedDateForDatePicker(this.state.data.record.startDate)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceDueDate" className="title1">تاریخ پایان<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.endDateString}</b>
													:
													<DatePicker
														inputReadOnly={false}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ اجرا"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.data.record.endDate = e }}
														value={this.getFormatedDateForDatePicker(this.state.data.record.endDate)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">شماره قرارداد<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.code}</b>
													:
													<input onChange={e => this.state.data.record.code = parseInt(e.target.value)} defaultValue={this.state.data.record.code} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">مبلغ اولیه قرارداد</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.originalAmount}</b>
													:
													<input onChange={e => this.state.data.record.originalAmount = parseInt(e.target.value)} defaultValue={this.state.data.record.originalAmount} type="text" className="form-control input-smnumber ltr" />
												}
											</div>
										</div>
										<div className="col-sm-12">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">یادداشت</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.note}</b>
													:
													<input onChange={e => this.state.data.record.notes = e.target.value} defaultValue={this.state.data.record.notes} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
									</div>
								</div>
								<div className="tab-pane" id="tab2" role="tabpanel">
									{this.state.data.record.guarantees.map(target =>
										<div className="row g-4" key={target.id} style={{ "background-color": "#f4f4f4", "marginBottom": "15px" }}>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">نوع تضمین</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.guaranteeTypeString}</b>
														:
														<div className="form-control-wrap">
															<select className="form-control" type="text" defaultValue={target.guaranteeType} onChange={e => this.setGuarantee(target.id, 'guaranteeType', parseInt(e.target.value))}>
																<option value="1">چک</option>
																<option value="2">سفته</option>
																<option value="3">وثیقه نقدی</option>
																<option value="4">وثیقه ملکی/سند</option>
															</select>
														</div>
													}
												</div>
											</div>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">مبلغ/ارزش</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.amount}</b>
														:
														<div className="form-control-wrap">
															<input className="form-control ltr" type="text" defaultValue={target.amount} onChange={e => this.setGuarantee(target.id, 'amount', parseInt(e.target.value))} />
														</div>
													}
												</div>
											</div>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">صادر کننده</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.issuer}</b>
														:
														<div className="form-control-wrap">
															<input className="form-control" type="text" defaultValue={target.issuer} onChange={e => this.setGuarantee(target.id, 'issuer', e.target.value)} />
														</div>
													}
												</div>
											</div>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">تاریخ اعتبار</label>
														<div className="form-control-wrap">
															<DatePicker
																inputReadOnly={false}
																className="form-control input-sm persian-date"
																placeholder={"تاریخ"}
																isGregorian={false}
																showTodayButton={true}
																timePicker={false}
																onChange={(e) => { this.setGuarantee(target.id, 'expiryDate', e) }}
																value={this.getFormatedDateForDatePicker(target.expiryDate)}
															/>
														</div>
												</div>
											</div>
											<div className="col-lg-1" style={{ "display": "flex", "align-items": "center" }}>
												<div className="form-group">
													{this.state.data.record.status === 1 && <a className="btn btn-sm btn-danger" onClick={e => this.removeGuarantee(target.id)}>حذف</a>}
												</div>
											</div>
										</div>
									)}
									{this.state.data.record.status === 1 && <div className="row g-4 mt-1">
										<div className="col-lg-12">
											<a className="btn btn-primary" onClick={e => this.addNewGuarantee()}>افزودن تضمین جدید</a>
										</div>
									</div>}
								</div>
								<div className="tab-pane" id="tab3" role="tabpanel">
									{this.state.data.record.retentions.map(target =>
										<div className="row g-4" key={target.id} style={{ "background-color": "#f4f4f4", "marginBottom": "15px" }}>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">نوع سپرده</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.typeString}</b>
														:
														<div className="form-control-wrap">
															<select className="form-control" type="text" defaultValue={target.type} onChange={e => this.setRetention(target.id, 'type', parseInt(e.target.value))}>
																<option value="1">حسن انجام کار</option>
																<option value="2">بیمه</option>
																<option value="3">پیش پرداخت</option>
															</select>
														</div>
													}
												</div>
											</div>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">مبلغ</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.amount}</b>
														:
														<div className="form-control-wrap">
															<input className="form-control ltr" type="text" defaultValue={target.amount} onChange={e => this.setRetention(target.id, 'amount', parseInt(e.target.value))} />
														</div>
													}
												</div>
											</div>
											<div className="col-lg-1" style={{ "display": "flex", "align-items": "center" }}>
												<div className="form-group">
													{this.state.data.record.status === 1 && <a className="btn btn-sm btn-danger" onClick={e => this.removeRetention(target.id)}>حذف</a>}
												</div>
											</div>
										</div>
									)}
									{this.state.data.record.status === 1 && <div className="row g-4 mt-1">
										<div className="col-lg-12">
											<a className="btn btn-primary" onClick={e => this.addNewRetention()}>افزودن سپرده جدید</a>
										</div>
									</div>}
								</div>
								{this.state.data.record.status > 1 && <div className="tab-pane" id="tab4" role="tabpanel">
									<div className="nk-tb-list nk-tb-ulist">
										<div className="nk-tb-item nk-tb-head">
											<div className="nk-tb-col text-center"><span className="sub-text">تاریخ تعدیل</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">جهت تعدیل</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">مبلغ تعدیل</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">علت تعدیل</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">فایل پیوست</span></div>
										</div>
										{this.state.data.record.adjustments.map((record, index) =>
											<div className="nk-tb-item">
												<div className="nk-tb-col">
													<span className="sub-text text-center">{record.effectiveDateString}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{record.typeString}</span>
												</div>
												<div className="nk-tb-col">
													{record.type === 1 && <span className="sub-text text-center">{this.money(record.adjustmentAmount)}</span>}
													{record.type === 2 && <span className="sub-text text-center">({this.money(record.adjustmentAmount)})</span>}
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.reason)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">
														{!this.isBlank(record.attachmentPath) && <a href={record.attachmentPath} target="_blank">مشاهده</a> }
													</span>
												</div>
											</div>
										)}
										<div className="row g-4 mt-1">
											<div className="col-lg-12">
												<a className="btn btn-primary" onClick={e => this.onAddAdjustment()}>افزودن تعدیلات جدید</a>
											</div>
										</div>
									</div>
								</div>}
							</div>

						</div>
						<div className="modal-footer">
							{this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>}
							{this.state.data.record.id != this.getDefaultGuid() && this.state.data.record.status === 1 && <button type="button" className="hand btn btn-success" onClick={e => this.start(e)} >فعال شدن</button>}
							{this.state.data.record.status !== 1 && <button type="button" className="hand btn btn-danger" onClick={e => this.getPdf(this.state.data.record.id)} >PDF</button>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}